export interface PerfilParam {
  id: string;
}

export enum FormInputName {
  name = 'name',
  email = 'email',
  phone = 'phone',
  birthDate = 'birthDate',
  motherName = 'motherName',
}

export enum FormInputNamePassword {
  password = 'password',
  confirmPassword = 'confirmPassword',
}

export enum FormInputNameAddress {
  id = 'id',
  zipCode = 'zipCode',
  state = 'state',
  city = 'city',
  district = 'district',
  street = 'street',
  complement = 'complement',
  number = 'number',
}

export interface UseModalControl {
  visible: boolean;
  title: string | React.ReactNode;
  shouldShowModal: ShowModalProfile;
  onShouldShowModal: ({ value, newTitle }: ShouldShowModalProps) => void;
  onToggleModal: () => void;
  onSetVisible: (visible: boolean) => void;
}

export type ShouldShowModalProps = {
  value: ShowModalProfile;
  newTitle: string | React.ReactNode;
};

export enum ShowModalProfile {
  BIOMETRIC_FACE = 'BIOMETRIC_FACE',
  CONFIRM_DELETE_CREDIT_CARD = 'CONFIRM_DELETE_CREDIT_CARD',
  CONFIRM_DELETE_PROFILE = 'CONFIRM_DELETE_PROFILE',
}

export interface ControllerDeleteProfile {
  onShowDeleteProfile: () => void;
  onSubmitDeleteProfile: () => void;
}

export enum FormInputNameFixClientData {
  name = 'name',
  email = 'email',
  phone = 'phone',
  birthDate = 'birthDate',
  motherName = 'motherName',
}

export enum FormInputNameFixAddress {
  id = 'id',
  zipCode = 'zipCode',
  state = 'state',
  city = 'city',
  district = 'district',
  street = 'street',
  number = 'number',
  complement = 'complement',
}
